import { Currency, DataTypeOptions } from '@core/constants/data-types.constants';
import { CurrencyAmount } from '../currency-amount.model';
import { MonetaryAmount, monetaryAmountToCurrencyAmount } from './monetary-amount.model';

export type Periodicity = 'monthly' | 'yearly' | 'weekly' | 'daily' | 'hourly' | 'minutely' | 'secondly';

const monthlyConversionRation = {
  monthly: 1,
  yearly: 0.0833334,
  weekly: 4.34524,
  daily: 30.4167,
  hourly: 730.001,
  minutely: 43800,
  secondly: 2.628e6
};
export interface PeriodicAmount {
  amount: MonetaryAmount;
  periodicity: Periodicity;
}

export function periodicAmountToMonthlyCurrencyAmount(
  periodicAmount: PeriodicAmount,
  currencies: DataTypeOptions<Currency>
): CurrencyAmount {
  const currencyAmount = monetaryAmountToCurrencyAmount(periodicAmount.amount, currencies);
  currencyAmount.amount *= monthlyConversionRation[periodicAmount.periodicity];
  return currencyAmount;
}
